module.exports = __webpack_public_path__ + "static/memory_img2M@2x-fd1a3db6e5a05c4b7647508b337085c9.png";